import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject, Subscription, throwError } from 'rxjs';
import { catchError, finalize, retry, retryWhen, take, tap } from 'rxjs/operators';
import { BaseResponse } from '../models/base-response.model';
import { EskaCoreMenu } from '../models/core-integration.model';
import { DataSourceService } from './data-source.service';
import * as datasources from 'src/assets/datasources.json';
import { AppError } from '../error-handler/app-error';

@Injectable({
  providedIn: 'root'
})
export class IntegrationService {
  public menuContent: any;

  private coreMenuSubject = new BehaviorSubject<BaseResponse<any>>(null);
  coreMenu$: Observable<BaseResponse<any>> = this.coreMenuSubject.asObservable();

  constructor(private http: HttpClient, private dataSourceService: DataSourceService) {
    const token = localStorage.getItem('coreToken');
    this.getCoreMenus(token).subscribe()
  }

  authorizedMenuGetter(params) {
    return this.http.post<BaseResponse<any>>(`/EskaCoreIntegrationApi/GetAuthorizedMenus`, params)
      .pipe(
        tap(() => console.log('started ...'))
      )
  }

  refreshTokenGetter(req) {
    return this.http.post<BaseResponse<any>>(`/EskaCoreIntegrationApi/RefreshToken`, req)
      .pipe(
        tap(() => console.log('refresh token started ...')),
        tap((res) => {
          if (res) {
            localStorage.setItem('coreToken', res.content.token);
            localStorage.setItem('coreRefreshToken', res.content.refreshToken);
          }
        })
      )
  }

  public eskaCoreMenus: EskaCoreMenu[] = [];
  private eskaCoreMenuContent = new BehaviorSubject<EskaCoreMenu[]>(this.eskaCoreMenus);
  data = this.eskaCoreMenuContent.asObservable();
  public dataSourcesData: any = (datasources as any).default;

  public isCoreIntegration(): boolean {
    const isIntegration = localStorage.getItem('coreIntegration');
    if (isIntegration === 'true') {
      return true;
    }
    return false;
  }

  public updateEskaCoreMenus(data: EskaCoreMenu[]) {
    this.eskaCoreMenuContent.next(data);
  }

  public getCoreMenus(token: string) {
    const refreshToken = localStorage.getItem('coreRefreshToken');

    let getCoreMenusParams = {
      Username: localStorage.getItem('coreUsername'),
      ComId: 1,
      AuthToken: localStorage.getItem('coreToken'),
      RefreshToken: localStorage.getItem('coreRefreshToken')
    };

    return this.authorizedMenuGetter(getCoreMenusParams)
      .pipe(
        tap((res) => res && this.coreMenuSubject.next(res)),
        catchError(err => {
          if (err.status == 401) {
            let req = { Token: token, RefreshToken: refreshToken };
            this.refreshTokenGetter(req)
              .subscribe(
                () => {
                  setTimeout(() => {
                    this.getCoreMenus(token).subscribe()
                  }, 1)

                }
              )
          } else {
            return throwError(err)
          }
        })
      )

  }

}
